import React, { useState, useEffect } from 'react';
import './plastic-type-form.scss';
import { Form } from '@ampol/design-system';
import { useSelector } from 'react-redux';
import * as yup from 'yup';
import Validation from 'constants/validation-messages';
import Regex from 'constants/regex';

/**
 * Form for adding new/editing existing plastic type
 * @returns JSX Element
 */
const PlasticTypeForm = ({ formId, isEdit, plasticType, onSubmit, onStateChange }) => {
  const updatePlasticTypeLoading = useSelector((state) => state.maintenanceStore.updatePlasticTypeLoading);
  const updatePlasticTypeLoaded = useSelector((state) => state.maintenanceStore.updatePlasticTypeLoaded);

  const [formValues, setFormValues] = useState({
    id: '',
    shortName: '',
    description: '',
    state: 'Active',
    cardImage: undefined
  });

  const formSchema = yup.object().shape({
    'id': yup.string()
      .required(Validation.PLASTIC_ID_REQUIRED)
      .matches(Regex.PLASTIC_TYPE_ID, Validation.PLASTIC_ID),
    'shortName': yup.string()
      .required(Validation.SHORT_NAME_REQUIRED)
      .matches(Regex.CARD_MAINTENANCE_ALPHA_NUM_SPACE_SPECIAL, Validation.CARD_MAINTENANCE_ALPHA_NUM_SPACE_SPECIAL)
      .max(50, Validation.MAX_CHAR_FIFTY),
    'description': yup.string()
      .required(Validation.DESCRIPTION_REQUIRED)
      .matches(Regex.CARD_MAINTENANCE_ALPHA_NUM_SPACE_SPECIAL, Validation.CARD_MAINTENANCE_ALPHA_NUM_SPACE_SPECIAL)
      .max(100, Validation.MAX_CHAR_ONE_HUNDRED),
    'state': yup.string().required(Validation.STATE_REQUIRED),
    'cardImage': isEdit ? '' : yup.mixed().test('cardImage', Validation.CARD_IMAGE_REQUIRED, (value) => { return value?.length > 0; })
  });

  useEffect(() => {
    if (isEdit && plasticType && !updatePlasticTypeLoaded && !updatePlasticTypeLoading) {
      setFormValues(plasticType);
    }
  }, [plasticType]);

  const onFormSubmit = (values) => {
    const request = mapFormValuesToRequest(values);

    if (isEdit && plasticType) {
      onSubmit(request, plasticType.id);
    } else {
      onSubmit(request);
    }
  };

  const mapFormValuesToRequest = (values) => {
    const request = {
      id: values.id,
      shortName: values.shortName,
      description: values.description,
      state: values.state,
      cardImage: values.cardImage?.[0]
    };

    return request;
  };

  return <div className={'plastic-type-form'}>
    <Form
      id={formId}
      schema={formSchema}
      onSubmit={onFormSubmit}
      onStateChange={onStateChange}
      defaultValues={formValues}
    >
      <div className="plastic-type-form__fields">
        <Form.Input
          label={'Plastic Type Id'}
          name={'id'}
          disabled={isEdit}
        />
        <Form.Input
          label={'Short Name'}
          name={'shortName'}
        />
      </div>
      <div className="plastic-type-form__fields plastic-type-form__fields--600">
        <Form.Input
          label={'Description'}
          name={'description'}
        />
      </div>

      <div className="plastic-type-form__fields">
        <Form.DropDown
          name="state"
          label="State"
          options={[
            { label: 'Active', value: 'Active' },
            { label: 'Disabled', value: 'Disabled' }
          ]}
        />

        {
          // TODO: Replace below with image upload component
        }

        <Form.FileUpload
          name={'cardImage'}
        />

        {isEdit && plasticType?.image?.url &&
          <img src={`${plasticType?.image?.url}?${new Date().getTime()}`} width="200" height="126" style={{ marginTop: '30px' }}></img>
        }
      </div>
    </Form>
  </div>;
};

export default PlasticTypeForm;
